/**
 * `um` ist die Änderung der Länge -- negativ beim Kürzen, positiv beim
 * Verlängern. Verglichen wird gegen den Anfang des getrimmten Clips und nicht
 * gegen sein Ende: liegt am nächsten Clip eine Blende, fängt der **vor** dem
 * Ende an, und gegen das Ende gemessen bliebe er liegen.
 */
export function nachruecken(clips, getrimmt, um) {
    if (um === 0)
        return [];
    return clips
        .filter((c) => c.id !== getrimmt.id && c.start > getrimmt.start)
        .sort((a, b) => a.start - b.start)
        // Unter null kann hier nichts landen -- ein Clip hinter dem getrimmten
        // fängt später an, als der aufhören kann. Die Klammer steht trotzdem da:
        // eine Zeitleiste mit einem negativen Anfang wäre nicht zu retten.
        .map((c) => ({ clipId: c.id, start: Math.max(0, c.start + um) }));
}
/**
 * Wie weit der hintere Griff gehen darf.
 *
 * Ohne Nachrücken ist der Nachbar die Grenze (`trimGrenzen`). Mit Nachrücken
 * gibt es keine: der Nachbar weicht ja aus. Was bleibt, ist die Quelle selbst
 * -- länger als das, was in der Datei steht, kann kein Clip werden.
 */
export function spaetestensMitNachruecken(clip, quellenLaenge) {
    if (quellenLaenge === null)
        return Number.POSITIVE_INFINITY;
    const uebrig = (quellenLaenge - clip.sourceIn) / clip.speed;
    return clip.start + Math.max(0, uebrig);
}
//# sourceMappingURL=nachruecken.js.map